var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDiamond = function SvgDiamond(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.98524 3.35919C6.17524 3.13157 6.45645 3 6.75294 3H17.2C17.4948 3 17.7746 3.13008 17.9646 3.35548L22.7646 9.04959C23.0787 9.42223 23.0784 9.96704 22.764 10.3394L12.7875 22.1511C12.5977 22.3758 12.3187 22.5055 12.0247 22.5059C11.7306 22.5062 11.4513 22.3771 11.2611 22.1529L1.23754 10.3411C0.92281 9.97027 0.9206 9.42673 1.2323 9.05331L5.98524 3.35919ZM7.22082 5L3.71992 9.19415H7.537L10.6566 5H7.22082ZM11.9029 5H12.1384L15.2234 9.19415H8.78329L11.9029 5ZM7.43687 10.1942H3.73587L10.1637 17.7688L7.43687 10.1942ZM12.0096 19.944L8.4997 10.1942H15.5031L12.0309 19.9474L12.0217 19.9582L12.0096 19.944ZM13.8657 17.775L20.2687 10.1942H16.5645L13.8657 17.775ZM16.4647 9.19415H20.2706L16.7351 5H13.3798L16.4647 9.19415Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDiamond);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/diamond.5103ade4008b82065e16642841b8c721.svg";